import fleet from "./fleet.component";
import fleetUrls from "./fleet.urls";
import FleetTransforms from "./fleet.transforms";

const fleetModule = angular
  .module("app.components.fleet", [])
  .component("fleetPage", fleet)
  .service("FleetTransforms", FleetTransforms)
  .config(fleetUrls);

export default fleetModule;



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.module.js